import React from 'react';
import { MdOutlineFullscreen, MdOutlineFullscreenExit } from 'react-icons/md';
import { useSelector } from 'react-redux';

function ChatFullScreenButton({ isBgLight }) {
  const { isChatFullScreen } = useSelector((state) => ({
    isChatFullScreen: state.messages.isChatFullScreen,
  }));
  
  const sendMessageToParent = (message) => {
    window.parent.postMessage(message, '*');
  };

  const handleFullScreen = () => {
    sendMessageToParent({
      type: 'CHAT_FULL_SCREEN',
      cond: !isChatFullScreen
    });
  };

  return (
    <div className='rcw-chat-full-icon' onClick={handleFullScreen}>
      {!isChatFullScreen ? 
          <MdOutlineFullscreen size={24} color={isBgLight ? '#000000' : '#ffffff'} /> 
        : 
          <MdOutlineFullscreenExit size={24} color={isBgLight ? '#000000' : '#ffffff'} />
      }
    </div>
  );
}

export default ChatFullScreenButton;
